/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Sample_Two_DetailInputs */

const en_coaches_page_sample_two_detail = /** @type {(inputs: Coaches_Page_Sample_Two_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physio · tomorrow morning`)
};

const pl_coaches_page_sample_two_detail = /** @type {(inputs: Coaches_Page_Sample_Two_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizjoterapeuta · jutro rano`)
};

/**
* | output |
* | --- |
* | "Physio · tomorrow morning" |
*
* @param {Coaches_Page_Sample_Two_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_sample_two_detail = /** @type {((inputs?: Coaches_Page_Sample_Two_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Sample_Two_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_sample_two_detail(inputs)
	return en_coaches_page_sample_two_detail(inputs)
});